import { EActivityAuditStatus } from '@constants';
import { IActivity } from '@sdk/contracts';
import { Popover, Space } from 'antd';

import { ActivityAuditStatusTag } from '@/components/ActivityAuditStatusTag';
import { useMutateActivity, useProfile } from '@/store';

type Props = {
  activity: IActivity;
};

export const ActivityAuditStatus: React.FC<Props> = ({ activity }) => {
  const { updateActivityAuditStatus } = useMutateActivity();
  const {
    roleCheck: { isManager }
  } = useProfile();

  const handleUpdateActivityAuditStatus = (auditStatus: EActivityAuditStatus) => {
    if (auditStatus === activity.auditStatus.currentStatus) return;
    updateActivityAuditStatus({ activityId: activity._id, auditStatus });
  };

  const content = (
    <Space direction="vertical">
      {Object.values(EActivityAuditStatus).map(auditStatus => (
        <ActivityAuditStatusTag
          key={auditStatus}
          auditStatus={auditStatus}
          onClick={() => handleUpdateActivityAuditStatus(auditStatus)}
        />
      ))}
    </Space>
  );

  if (!isManager)
    return <ActivityAuditStatusTag iconOnly auditStatus={activity.auditStatus.currentStatus} />;

  return (
    <Popover content={content} placement="top" trigger="click">
      <ActivityAuditStatusTag iconOnly auditStatus={activity.auditStatus.currentStatus} />
    </Popover>
  );
};
